// extracted by mini-css-extract-plugin
module.exports = {"btnGreenTransparent32":"BtnGreenTransparent32_btnGreenTransparent32__38c9h"};